import SparklesIcon from "lucide-react/dist/esm/icons/sparkles";
import type { SkillMention } from "@quake/isomorphic/skill-mentions";

export const skillMentionClassName =
  "inline-flex items-center gap-1 rounded-md border border-border bg-muted px-1.5 py-0.5 align-baseline text-[0.9em] font-medium leading-none text-foreground";

export function SkillMentionBadge({ id, label }: SkillMention) {
  return (
    <span className={skillMentionClassName} data-skill-id={id} data-type="skill-mention">
      <SparklesIcon className="size-3 shrink-0" aria-hidden="true" />
      {label}
    </span>
  );
}
